import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="form-step"
export default class extends Controller {
    static outlets = ["step-form", "form-step"]
    static targets = ["step"]

    updateStep(event) {
        this.stepFormOutlet.changeStep(event, event.currentTarget.dataset.step)
        this.stepFormOutlet.addEventTimes(event)
        this.formStepOutlets.forEach(outlet => {
          if(outlet._is_active() && this.element.dataset.index < outlet.element.dataset.index) {
            this.stepFormOutlet.removeRequired()
            if(this.stepFormOutlet.element.id.includes("event-form")) this.stepFormOutlet.changeUrl()
         }
        })
    }

    _is_active() {
        return this.stepTarget.classList.contains("active")
    }
}
